import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";
import AskLauncher from "../components/AskLauncher";
import { useSession } from "../context/SessionContext";

const DashboardLayout = () => {
  const { session, loading, allowedModules } = useSession();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try { return localStorage.getItem("ang-sidebar-collapsed") === "1"; } catch { return false; }
  });

  const toggleCollapse = () => {
    setSidebarCollapsed((v) => {
      const next = !v;
      try { localStorage.setItem("ang-sidebar-collapsed", next ? "1" : "0"); } catch { /* ignore */ }
      // Nudge Recharts to remeasure once the sidebar transition finishes.
      setTimeout(() => window.dispatchEvent(new Event("resize")), 220);
      return next;
    });
  };

  useEffect(() => {
    if (!loading && !session) {
      navigate("/", { replace: true });
    }
  }, [session, loading, navigate]);

  useEffect(() => {
    if (!session || allowedModules.length === 0) return;
    const seg = pathname.split("/")[2];
    if (seg && !allowedModules.includes(seg)) {
      navigate(`/app/${allowedModules[0]}`, { replace: true });
    }
  }, [pathname, allowedModules, session, navigate]);

  // close drawer on route change
  useEffect(() => {
    setSidebarOpen(false);
  }, [pathname]);

  // Reset scroll to top on route change — otherwise on mobile the new page
  // opens mid-scroll wherever the previous page left the viewport.
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  if (!session) return null;

  return (
    <div className="min-h-screen flex ang-paper" data-testid="dashboard-shell">
      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-backdrop"
        />
      )}

      <Sidebar
        open={sidebarOpen}
        onNavItemClick={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleCollapse}
      />

      <main className="flex-1 min-w-0 flex flex-col">
        <TopBar onMenu={() => setSidebarOpen(true)} />
        <div className="p-4 md:p-6 lg:p-8 flex-1 overflow-x-hidden">
          <Outlet />
        </div>
      </main>

      {/* Floating "Ask" launcher — global across every module */}
      <AskLauncher />
    </div>
  );
};

export default DashboardLayout;
